import {
  QAlertBox,
  QAlertDescription,
  QFlex,
  QIconButton,
  QSpacer,
} from "@qualio/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  onRefresh: () => void;
};

export const ReviewRefreshAlert: React.FC<Props> = ({ onRefresh }) => {
  const { t } = useTranslation();
  return (
    <QAlertBox status="warning" alignItems="center">
      <QFlex alignItems="center">
        <QAlertDescription>
          {t("reviews.overview.alerts.outdatedDesignElementsRefresh")}
        </QAlertDescription>
        <QSpacer />
        <QIconButton
          iconName="RefreshCw"
          onClick={onRefresh}
          data-cy="refreh-all-design-elements"
          aria-label={t("common.ariaLabels.updateAllToLatestVersion")}
        />
      </QFlex>
    </QAlertBox>
  );
};

// ensure QHeader can show component
ReviewRefreshAlert.displayName = "QAlert";
